import type {
  AvailableDateField,
  ReportDashboardComponentKind,
  ReportDashboardMetricOptions,
} from '@core/reports-types';

import { getComponentDatePoint } from './get-component-date-point';

export const getAvailableDateFields = (
  component: { kind: ReportDashboardComponentKind; endPoint?: string | null },
  metric: ReportDashboardMetricOptions,
): AvailableDateField[] => {
  const datePoint = getComponentDatePoint(component, metric);
  return [...metric.availableDateFields, ...(datePoint?.availableDateFields ?? [])];
};
